import { Flow } from 'signup-constants/Flow';
import { ExperimentKeys, TEST_KEY } from './ExperimentKeys';
import { enrollOnFlow } from './experimentDefaults';
import { getIsExistingUserSession, getIsNewUser } from '../store/app/selectors';
import { getIsGoogleCredentialAuthentication } from '../google-authentication/google-prompt/useGoogleCredentialForAuthentication';
import { getFlowKey } from '../routing/getFlowKey';
import { getIsNewUserExperiment } from './ExperimentUtils';
import { getIsJapan } from '../utils/getIsJapan';
import { getQueryParam } from '../routing/getQueryParam';
import { getIsMobile } from '../utils/deviceUtils';
import { SignupEmbedder } from 'signup-embedder';
import { getIntentKey } from '../routing/getIntentKey';
import enviro from 'enviro';
export const EXPERIMENT_ID = 'experimentId';
const SEEN_EXPERIMENTS = new Set();
const Experiments = new Map([[ExperimentKeys.ACQ0170, {
  shouldEnroll: state => {
    const activeFlows = [Flow.Crm, Flow.Sales, Flow.Marketing, Flow.Service, Flow.CmsFree];
    const isJapan = getIsJapan(state);
    const isOnActiveFlow = activeFlows.includes(getFlowKey());
    return isOnActiveFlow && isJapan;
  }
}], [ExperimentKeys.ACQ0172, {
  shouldEnroll: state => {
    const activeFlows = [Flow.Crm, Flow.Sales, Flow.Marketing, Flow.Service];
    const isOnActiveFlow = activeFlows.includes(getFlowKey());
    const isNewUser = getIsNewUserExperiment(state);
    const isJapan = getIsJapan(state);
    const isMobile = getIsMobile();
    const isEmbedded = SignupEmbedder.isActive();
    const intentKey = getIntentKey();
    const isComingFromGooglePrompt = getIsGoogleCredentialAuthentication(state);
    const existingUserFlowEnabled = getQueryParam('existing_user_flow') === 'true';
    const isExistingUserFlow = getIsExistingUserSession(state);
    const isQA = enviro.isQa();
    const enrollForNewUserFlow = isOnActiveFlow && isNewUser && !isJapan && !isMobile && !isEmbedded && !intentKey && !isComingFromGooglePrompt;

    // This is a temporary feature so we can run the flow end to end in user testing
    const enrollForExistingUserFlow = isExistingUserFlow && isQA && existingUserFlowEnabled && !isJapan && !isMobile && !isEmbedded && !intentKey && !isComingFromGooglePrompt;
    return enrollForNewUserFlow || enrollForExistingUserFlow;
  }
}], [ExperimentKeys.ACQ0173, {
  shouldEnroll: state => {
    const activeFlows = [Flow.Crm, Flow.Sales, Flow.Marketing, Flow.Service];
    const isNewUser = getIsNewUserExperiment(state) || getIsNewUser(state);
    const isOnActiveFlow = activeFlows.includes(getFlowKey());
    const searchPrefillEnabled = getQueryParam('search_prefill_enabled') === 'true';
    const isJapan = getIsJapan(state);
    return isNewUser && isOnActiveFlow && searchPrefillEnabled && !isJapan;
  }
}], [ExperimentKeys.ACQ0176, {
  shouldEnroll: state => {
    const isNewUser = getIsNewUserExperiment(state);
    return isNewUser;
  }
}]]);
export const getExperiment = id => {
  // we want to prefer this solution over mocking getExperiment so that the
  // seen experiments tracking below continues to work and doesn't get
  // accidentally mocked
  if (id === TEST_KEY) {
    return {
      shouldEnroll: () => enrollOnFlow([Flow.Crm])
    };
  }
  SEEN_EXPERIMENTS.add(id);
  return Experiments.get(id);
};
export function getSeenExperimentsForTesting() {
  return Array.from(SEEN_EXPERIMENTS);
}